import { Box } from "@raca2022/uikit";
import styled from "styled-components";

export const Container = styled(Box)`
    width: 100%;
    padding: 5vw 4vw 3.5vw;
    h1{
        font-weight: 700;
        font-size: 50px;
        line-height: 110%;
        color: #144456;
        font-family: 'PoppinsBold';
        width: 100%;
        text-align: center;
        margin-bottom: 52px;
    }
    @media only screen and (min-width: 1920px){
        padding: 100px 80px 70px;
    }
    @media only screen and (max-width: 1024px) {
        h1{
            font-size: 3.73vw;
        }
    }
    @media only screen and (max-width: 430px) {
        h1{
            font-size: 18px;
        }
    }
`
export const Content = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    img{
        min-width: 110px;
        width: 15%;
        max-width: 260px;
    }
    a{
        min-width: 110px;
        width: 15%;
        max-width: 260px;
        img{
            min-width: 100%;
            width: 100%;
            max-width: 100%;
        }
    }
    @media only screen and (max-width: 1024px) {
        img{
            width: 19.7vw;
        }
    }
`